import { render, staticRenderFns } from "./RelatorioLpsNaoVisitaListRoute.vue?vue&type=template&id=4d706d3f"
import script from "./RelatorioLpsNaoVisitaListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioLpsNaoVisitaListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports